import(/* webpackMode: "eager" */ "/home/ubuntu/download/69ae55e0886e10001459d1f2/xinyuee/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69ae55e0886e10001459d1f2/xinyuee/src/app/business-scope/components/BusinessChannels.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69ae55e0886e10001459d1f2/xinyuee/src/app/business-scope/components/ProductCategories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69ae55e0886e10001459d1f2/xinyuee/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69ae55e0886e10001459d1f2/xinyuee/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69ae55e0886e10001459d1f2/xinyuee/src/components/ui/AppLogo.tsx");
